module.exports = __webpack_public_path__ + "img/small-play.b507b8a2.svg";